(function () {
    'use strict';
    var controllerId = 'cndPDocenteAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'partDocente', 'province', 'paesi', 'tProfiloDocenti', 'partecipazioneId', 'isSuper', cndPDocenteAdd]);

    function cndPDocenteAdd($scope, datacontext, $uibModalInstance, partDocente, province, paesi, tProfiloDocenti, partecipazioneId, isSuper) {
        $scope.province = province;
        $scope.paesi = paesi;
        $scope.tProfiloDocenti = tProfiloDocenti;
        $scope.comuni = [];
        $scope.validCF = true;
        $scope.checkCF = checkCF;
        $scope.existCF = false;
        $scope.existsCF = existsCF;

        if (partDocente) {
            $scope.title = 'Modifica Docente';
            $scope.record = jQuery.extend({}, partDocente); //Clona oggetto
            if (typeof $scope.record.CodiceFiscale != 'undefined' && $scope.record.CodiceFiscale.length > 0) {
                checkCF($scope.record.CodiceFiscale);
            }
            if ($scope.record.NascProvinciaId > 0) {
                getComuni($scope.record.NascProvinciaId);
            }
            if ($scope.record.NascData != null) {
                $scope.record.NascData = new Date($scope.record.NascData);
            }
        }
        else {
            $scope.title = 'Nuovo Docente';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.TIndirizzoId = 1;
            $scope.record.NascComuneId = '';
            $scope.record.NascPaeseId = 0;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            //return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1) {
                console.log('iOpened == 1');
                $scope.opened1 = true;
            }
                
        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                $scope.record.NascData = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";

        if (partecipazioneId) {
            $scope.partecipazioneId = partecipazioneId;
            $scope.record.CNDPartecipazioneId = partecipazioneId;
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.record.Id == 0) {
                    var result = addItem($scope.record);
                    $uibModalInstance.close(result);
                }
                else {
                    var result1 = updateItem($scope.record);
                    $uibModalInstance.close(result1);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.pDocente_add(item).then(function (data) {
                return data;
            });
        }

        function updateItem(item) {
            return datacontext.pDocente_merge(item).then(function (data) {
                return data;
            });
        }

        $scope.change_Paesi = function () {
            if ($scope.record.NascPaeseId > 0) {
                $scope.record.NascProvinciaId = 0;
                $scope.record.NascComuneId = 0;
            }
        };

        $scope.change_Comuni = function (idprov) {
            //console.info('change_Comuni()', idprov);
            $scope.record.NascComuneId = '';
            getComuni(idprov);
        };

        function getComuni(idprov) {
            //console.info('getComuni()', idprov);
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.NascProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

        function checkCF(_value) {
            $scope.validCF = true;
            if (typeof _value == 'undefined') return;
            if (_value.length != 16) return;
            $scope.validCF = false;
            return datacontext.validazione_cf(_value, false).then(function (data) {
                return $scope.validCF = data;
            });
        }

        function existsCF(_value) {
            $scope.existCF = false;
            if (typeof _value == 'undefined') return;
            if (_value.length != 16) return;
            $scope.existCF = true;
            return datacontext.pDocente_exists($scope.record.CNDPartecipazioneId, _value, 0).then(function (data) {
                return $scope.existCF = data;
            });
        }

    }
})();